// extracted by mini-css-extract-plugin
export var actions = "_l2-g";
export var benefitCard = "_l2-b";
export var benefitIcon = "_l2-d";
export var benefitLabel = "_l2-f";
export var benefits = "_l2-a";
export var benefitsSection = "_l2-8";
export var bodyText = "_l2-7";
export var closeButton = "_l2-2";
export var content = "_l2-3";
export var eyebrow = "_l2-4";
export var heading = "_l2-5";
export var image = "_l2-i";
export var imagePanel = "_l2-h";
export var modal = "_l2-0";
export var offerCard = "_l2-c";
export var offerIcon = "_l2-e";
export var sectionLabel = "_l2-9";
export var shell = "_l2-1";
export var title = "_l2-6";